import { Grid } from "@mui/material";
import React, { useState } from "react";
import RGL, { WidthProvider } from "react-grid-layout";
import { useMutation, useQuery } from "react-query";
import {
  DashboardRequest
} from "../../../models/dashboard.model";
import { DeleteUserDashboard, GetUserDashboards, UpdateUserDashboardsConfig } from "../../../services/dashboard.service";

import CssBaseline from "@material-ui/core/CssBaseline";
import Layout, {
  getContent,
  Root
} from "@mui-treasury/layout";
import styled from "styled-components";
import { v4 as uuidv4 } from 'uuid';
import { ApiResultModel } from "../../../models/common.model";
import "./Styles.css";
import UserDashboardViewer from "./userDashboardViewer/UserDashboardViewer";
import BrushIcon from '@mui/icons-material/Brush';




// import UserDashboardViewer from "./userDashboardViewer/userDashboardViewer";
const Content = getContent(styled);
const scheme = Layout();

scheme.configureHeader((builder) => {
  builder
    .create("whatever_id")
    .registerConfig("xs", {
      position: "sticky",
    })
    .registerConfig("md", {
      position: "relative", // won't stick to top when scroll down
    });
});



let staticLayout: any = [];

const ReactGridLayout = WidthProvider(RGL);
const UserDashboard = () => {
  let { data, isLoading, refetch } = useQuery<DashboardRequest[]>(
    "GetUserDashboards",
    (): Promise<DashboardRequest[]> => {
      return GetUserDashboards();
    },
    {
      onSuccess: (data) => {
        if (data && data.length > 0) {
          let dataTemp: any[] = [];
          data.map((item: any, idx: any) => {
            let configObj = JSON.parse(item.jsonConfig);
            configObj.i = uuidv4();
            Object.assign(item, configObj);

            dataTemp.push(item);
          });

          staticLayout = dataTemp;
          setLayout(dataTemp);
        }
      },
    }
  );

  const UpdateUserDashboardMutation = useMutation(UpdateUserDashboardsConfig, {
    onSuccess: (result: ApiResultModel<boolean>) => {
      if (result.isSuccess == true) {
      }
    },
    onError: () => { },
  });

  const DeleteUserDashboardMutation = useMutation(DeleteUserDashboard, {
    onSuccess: (result: ApiResultModel<boolean>) => {
      if (result.isSuccess == true) {
        refetch();
      }
    },
    onError: () => { },
  });

  //Events Handlers
  const onDragStop = (layout: any, oldItem: any, newItem: any) => {
    let layoutTemp: any[] = [];

    if (newItem.x % 3 != 0) {
      refetch();
      return;
    }

    layout.map((item: any, idx: any) => {
      let obj = staticLayout.find((e: { i: any; }) => e.i === item.i);
      item.i = uuidv4();
      if (obj != undefined) {
        item.name = obj.name;
        item.orderIndex = obj.orderIndex;
        item.userDashboardId = obj.userDashboardId;
        item.dashboardItems = obj.dashboardItems;
      }

      layoutTemp.push(item);
    });

    let sortedLayout = layoutTemp.sort((a, b) => parseFloat(a.x) - parseFloat(b.x)).reverse().sort((a, b) => parseFloat(a.y) - parseFloat(b.y));

    layoutTemp = [];
    var queue: any = [];
    sortedLayout.map((item: any, idx: any) => {
      queue.push(item);
      layoutTemp.push(item);
    });

    let counter: number = 0;
    while (queue.length !== 0) {
      let item = queue.shift();

      item.orderIndex = ++counter;
      layoutBuilder(item, item.orderIndex);
      item.jsonConfig = JSON.stringify({ h: item.h, w: item.w, x: item.x, y: item.y });
    }

    staticLayout = layoutTemp;
    setLayout(layoutTemp);

    let updateResult = UpdateUserDashboardMutation.mutateAsync({ dashboards: layoutTemp });
  }

  const layoutBuilder = (obj: any, order: number, h: number = 2, w: number = 3) => {
    let xvlaue: number = 0;
    if (order % 3 == 1)
      xvlaue = 6;
    else if (order % 3 == 2)
      xvlaue = 3;

    let yValue: number = Math.floor((order - 1) / 3) * 2;

    obj.x = xvlaue;
    obj.y = yValue;
  }

  const handleDeleteUserDashboard = (item: any) => {
    let deleteResult = DeleteUserDashboardMutation.mutateAsync({ id: item.userDashboardId });
  }


  const [layout, setLayout] = useState<any[]>();
  return (
    <div className="user-dashboard" style={{ direction: "ltr" }}>
      <Root scheme={scheme}>
        <CssBaseline />

        <div>
          <Content>
            {" "}
            <Grid item xs={12}>
              {(layout == null || layout == undefined || layout.length == 0) ? <div className="centered">
                <div >
                  <div style={{ display: "flex", justifyContent: "center", alignItems: "center", paddingBottom: "2vh" }}>
                    <BrushIcon className="subColor " style={{ width: "48px", height: "48px" }}></BrushIcon>
                  </div>
                  <div className="subColor textFont20  ">داشبوردی برای نمایش و مدیریت وجود ندارد</div>
                </div>
              </div> :
                <ReactGridLayout
                  cols={9}
                  layout={layout} //{{ lg: rightItems, md: rightItems }}
                  isResizable={false}
                  onDragStop={(layout, oldItem, newItem) => { onDragStop(layout, oldItem, newItem); }}
                  onResizeStop={(layout, oldItem, newItem) => { }}
                >
                  {layout?.map((item: any, idx: any) => (
                    <div
                      key={item.i}
                      data-grid={item}
                      id={"right" + item.i}
                      className="dashboard-div"
                    >
                      <UserDashboardViewer item={item} onDeleteClick={handleDeleteUserDashboard} />
                      <Grid container spacing={1}>
                        {item.dashboardItems.map((dashboardItems: any, idx: any) => (
                          <>
                            {item.dashboardItems?.length >= 4
                              && idx <= 3
                              && (<><Grid item xs={6}>
                                <img
                                  src={`images/dashboard/search/sample-${dashboardItems.pbiReportTypeId}.png`}
                                  className="iconeSide dashboard-img-four-section"
                                />
                              </Grid></>)}

                            {item.dashboardItems?.length == 3
                              && (<>{idx !== 2 ?
                                (<><Grid item xs={6}>
                                  <img
                                    src={`images/dashboard/search/sample-${dashboardItems.pbiReportTypeId}.png`}
                                    className="iconeSide dashboard-img-four-section"
                                  />
                                </Grid></>) :
                                (<><Grid item xs={12}>
                                  <img
                                    src={`images/dashboard/search/sample-${dashboardItems.pbiReportTypeId}.png`}
                                    className="iconeSide dashboard-img-four-section"
                                  />
                                </Grid></>)}</>)}

                            {item.dashboardItems?.length == 2
                              && (<><Grid item xs={6}>
                                <img
                                  src={`images/dashboard/search/sample-${dashboardItems.pbiReportTypeId}.png`}
                                  className="iconeSide dashboard-img-two-section"
                                />
                              </Grid></>)}

                            {item.dashboardItems?.length == 1
                              && (<><Grid item xs={12}>
                                <img
                                  src={`images/dashboard/search/sample-${dashboardItems.pbiReportTypeId}.png`}
                                  className="iconeSide dashboard-img-one-section"
                                />
                              </Grid></>)}
                          </>

                        ))}
                      </Grid>
                    </div>
                  ))}
                </ReactGridLayout>
              }
            </Grid>
          </Content>
        </div>
      </Root>
    </div>
  );
};

export default UserDashboard;
